module.exports = __webpack_public_path__ + "media/src/assets/Images/InputChecked-a243e5f5231bc465a2b39769c2ed2fb8.svg";